import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  PumpAlgorithm,
  PumpAlgorithmState,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { DataRecency } from "src/types"

export function getPumpAlgorithmState(
  pumpStatus: PumpStatus,
  pumpStatusRecency: DataRecency,
): PumpAlgorithmState {
  const {
    pump_algorithm: pumpAlgorithm,
    algorithm_state: pumpAlgorithmState,
  } = pumpStatus

  if (pumpStatusRecency === DataRecency.Stale) {
    return PumpAlgorithmState.NoData
  }

  if (pumpAlgorithm === PumpAlgorithm.NoData) {
    return PumpAlgorithmState.NoData
  }

  return pumpAlgorithmState
}
